import { Event } from '@mirai/data-sources';
import { useLocale } from '@mirai/locale';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { DEFAULT_LANGUAGE, SCRIPT_URL, SUPPORTED_LANGUAGES } from './FormShift4.constants';
import { loadScript } from '../../../../../helpers/loadScript';
import { EVENT } from '../../../../helpers';

export const FormShift4 = ({ response, onClose = () => {} }) => {
  const { language } = useLocale();

  const [ready, setReady] = useState();

  useEffect(() => {
    (async () => {
      await loadScript({
        async: false,
        domain: 'payments',
        id: 'shift4Script',
        src: SCRIPT_URL,
        onLoad: handleLoad,
      });
    })();
  }, [response]);

  useEffect(() => {
    if (!response || !ready) return;

    const { Shift4Checkout } = window || {};
    const { configuration: { clientSecret, email, publicKey } = {} } = response;

    Shift4Checkout.key = publicKey;
    Shift4Checkout.success = handleSuccess;
    Shift4Checkout.error = handleError;
    Shift4Checkout.close = onClose;

    Shift4Checkout.open({
      clientSecret,
      email,
      locale: SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, response]);

  const handleError = (errorMessage) => {
    Event.publish(EVENT.NOTIFICATION, {
      error: true,
      defaultMessage: errorMessage,
    });
  };

  const handleLoad = async () => {
    setReady(true);
  };

  const handleSuccess = (result) => {
    if (!result) return;

    const { configuration: { paymentTransactionId, returnUrl } = {} } = response;
    const url = new URL(returnUrl);
    paymentTransactionId && url.searchParams.append('paymentTransactionId', paymentTransactionId);

    window.location.href = url.toString();
  };

  return null;
};

FormShift4.displayName = 'Mirai:Payments:ButtonPayment:FormShift4';

FormShift4.propTypes = {
  response: PropTypes.object,
  onClose: PropTypes.func,
};
